import AppModel from './AppModel';
import AppView from '../views/AppView';

export default class App {
    constructor(value) {
        this.slider = document.querySelector('.slider');
        this.radioButton = document.querySelector('.radioButton');
        this.numberCard = getComputedStyle(document.body).getPropertyValue('--card');
        this.value = value;
        this.key = 'AIzaSyCTWC75i70moJLzyNh3tt4jzCljZcRkU8Y';
        this.state = {
            url: `https://www.googleapis.com/youtube/v3/search?key=${this.key}&type=video&part=snippet&maxResults=15&q=${this.value}`,
        };
        this.nextVideo = null;
        this.currentSheet = 0;
        this.howManySheets = 0;
        this.initListener();
    }

    initListener() {
        this.radioButton.addEventListener('click', this.continueButton.bind(this), false);
        this.slider.addEventListener('scroll', this.continueScroll.bind(this), false);
    }

    async start() {
        const model = new AppModel(this.state);
        this.nextVideo = await model.getNextPage();
        const id = await model.getId();
        this.state.url2 = `https://www.googleapis.com/youtube/v3/videos?key=${this.key}&id=${id.join(',')}&part=snippet,statistics`;
        const data = await model.getInfo();
        const view = new AppView(data);
        view.render();
    }

    continueScroll() {
        const scroll = this.slider.scrollLeft;

        const styleCard = document.querySelector('.card');

        if (styleCard) {
            const width = parseInt(getComputedStyle(styleCard).getPropertyValue('width'), 10);
            const margin = parseInt(getComputedStyle(styleCard).getPropertyValue('margin-right'), 10);
            this.cards = document.getElementsByClassName('card').length;
            const widthOfAllCards = (width - margin) * (this.cards - this.numberCard);
            const widthOfAllCardsWithoutTabs = widthOfAllCards - margin;

            if (scroll <= widthOfAllCards && scroll >= widthOfAllCardsWithoutTabs) {
                this.giveNextVideo();
                this.currentSheet += +this.numberCard;
            }
        }
    }

    continueButton(e) {
        const side = +e.target.value;
        this.cards = document.getElementsByClassName('card').length;
        this.howManySheets = Math.floor(this.cards / this.numberCard);

        if (side) this.currentSheet += 1;
        else this.currentSheet -= 1;

        if (this.currentSheet === this.howManySheets) {
            this.giveNextVideo();
        }
    }

    async giveNextVideo() {
        this.state.url = `https://www.googleapis.com/youtube/v3/search?key=${this.key}&type=video&part=snippet&maxResults=15&q=${
            this.value
        }&pageToken=${this.nextVideo}`;
        this.start();
    }
}
